import React from "react";
import {
    ColorPickerInput,
    Form,
    InputControl,
    NumberInput,
    StyleFunction,
    useMerchantConfig,
    useThemedStyle,
} from "@venuepos/react-common";
import { useTranslation } from "react-i18next";
import { BuyAccountFundsButtonType, parseAmount } from "lib";
import { View } from "react-native";

export function BuyAccountFundsSubForm({
    form: [{ errors, values }, { setValue }],
}: {
    form: Form<BuyAccountFundsButtonType>;
}) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);
    const merchantConfig = useMerchantConfig();

    return (
        <View style={[styles.rowContainer, styles.onTop]}>
            <InputControl
                style={styles.firstColumn}
                error={errors.amount}
                description={t(
                    "layout.function_button_form.buy_funds_amount",
                    "Leave field blank to let the amount be decided by the cashier"
                )}
            >
                <NumberInput
                    label={t("common.amount", "Amount")}
                    defaultValue={values?.amount ? values.amount / 100 : null}
                    onChange={value => {
                        setValue("amount", value ? parseAmount(value) : 0);
                    }}
                    min={0}
                    unit={merchantConfig.currency}
                />
            </InputControl>
            <InputControl error={errors.color} style={styles.lastColumn}>
                <ColorPickerInput
                    label={t(
                        "layout.function_button_form.button_color",
                        "Color of the button"
                    )}
                    defaultColor={values?.color ?? undefined}
                    onChangeColor={newColor => {
                        if (newColor !== values?.color) {
                            setValue("color", newColor ?? null);
                        }
                    }}
                />
            </InputControl>
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    rowContainer: {
        flexDirection: "row",
    },
    onTop: { zIndex: 2 },
    firstColumn: {
        flex: 1,
        paddingRight: theme.spacingScale,
    },
    lastColumn: {
        flex: 1,
    },
});
